import { withPriceData } from './PriceDataContext';
import PriceDataProvider from './PriceDataProvider';

export default PriceDataProvider;
export { withPriceData };
